export function capitalizeText(str) {
    if (!str) return '';
    return str
      .replace(/[-_]+/g, ' ')          // replace hyphen/underscore with space
      .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
  }
  